import { Menu } from '@mui/material'
import clsx from 'clsx'
import { RotatingChevronIcon } from 'components/core-v2'
import { noop } from 'lodash'
import { FC, useCallback, useRef, useState } from 'react'
import { ClassName } from 'types/props'

import classes from './index.module.scss'

interface Props extends ClassName {
  id: string
  label: string
  onClose?: () => void
}
export const DropdownMenu: FC<Props> = ({ children, className, id, label, onClose = noop }) => {
  const buttonRef = useRef(null)
  const [isOpen, setIsOpen] = useState(false)

  const closeMenu = useCallback(() => {
    onClose()
    setIsOpen(false)
  }, [onClose])
  const toggleMenu = useCallback(() => setIsOpen(isOpen => !isOpen), [])

  return (
    <div className={clsx(classes.root, className)}>
      <button
        ref={buttonRef}
        aria-controls={id}
        aria-haspopup="true"
        className={classes.button}
        type="button"
        onClick={toggleMenu}
      >
        {label}
        <RotatingChevronIcon classNames={{ root: classes.chevron }} isRotated={isOpen} />
      </button>

      <Menu
        keepMounted
        anchorEl={buttonRef?.current}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        aria-labelledby="menubutton"
        classes={{ paper: clsx(classes.menu, { [classes.menuOpen]: isOpen }) }}
        id={id}
        open={isOpen}
        role="menu"
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        onClose={closeMenu}
      >
        {children}
      </Menu>
    </div>
  )
}
